// Components
import { CalculationTwoDaysParams } from '../calculation-two-days-params/Calculation-two-days-params';
import { BtnApplyNewRate } from '../btn-apply-new-rate/Btn-apply-new-rate';
// Styles
import styles from './CalculationThreeDays150Result.module.css';
import { BtnApplyNewTemplate } from '../btn-apply-new-template/Btn-apply-new-template';
import { CalculationThreeDays150Params } from '../calculation-three-days-150-params/Calculation-three-days-150-params';

export const CalculationThreeDays150Result = (props) => {
  const { calculationData, sameDepartmentSettings, applyNewRates, formChange, resetLastTarget, checkboxValueChange,
    editorState,
    tags,
    setPreviewText, setOptionsPreviewText,
    popUpShown, oldTemplateWasUsed, applyNewTemplate, setShowGenerateEmail, furniture, roomsAreas, setTagsValuesDefault, customTagsValues } = props;
  const commonValues = { ...calculationData.commonValues };
  const threeDays150Miles = { ...calculationData.threeDays150Miles };
  const department = { ...calculationData.department };
  const unpDepartment = { ...calculationData.unpDepartment };
  const selectedMiscCheckMarks = calculationData.selectedMiscCheckMarks

  return (
    <section className={styles.container}>
      <h2 className={styles.title}>Calculation Three days 150</h2>
      {!sameDepartmentSettings && <div className={styles.oldApplyNew}><h2 className={styles.title} style={{ color: "red" }}>Old department settings were used</h2>
        <BtnApplyNewRate
          isActive={true}
          action={applyNewRates}
          name={'Apply new rates'}
        />
      </div>}
      {calculationData &&
        <div className={styles.selectedInfo}>
          {calculationData.calculationNumber && <p className={styles.calculationNumber}>{calculationData.calculationNumber}</p>}
          {calculationData.department && <p className={styles.departmentName}>{calculationData.department.departmentName}</p>}
          {calculationData.threeDays150Miles.firstDayRate && <p className={styles.rateName}>{calculationData.threeDays150Miles.firstDayRate}</p>}
          {calculationData.threeDays150Miles.secondDayRate && <p className={styles.secondRateName}>{calculationData.threeDays150Miles.secondDayRate}</p>}
          {calculationData.threeDays150Miles.thirdDayRate && <p className={styles.thirdRateName}>{calculationData.threeDays150Miles.thirdDayRate}</p>}
        </div>
      }
      {oldTemplateWasUsed && <div className={styles.oldApplyNew}><h2 className={styles.title} style={{ color: "#0000ff" }}>Old template settings were used</h2>
        <BtnApplyNewTemplate
          isActive={true}
          action={applyNewTemplate}
          name={'Apply new Template'}
        />
      </div>}
      <div className={styles.selectedInfo}>
        {threeDays150Miles.firstDayDate && <p className={styles.calculationDate} style={{ marginRight: '4px' }}>{new Date(threeDays150Miles.firstDayDate).toLocaleDateString('en-us', { weekday: 'short', year: 'numeric', month: 'numeric', day: 'numeric', timeZone: 'UTC' })}</p>}
        {threeDays150Miles.secondDayDate && <p className={styles.calculationDate}>{threeDays150Miles.firstDayDate && '&  '} {new Date(threeDays150Miles.secondDayDate).toLocaleDateString('en-us', { weekday: 'short', year: 'numeric', month: 'numeric', day: 'numeric', timeZone: 'UTC' })}</p>}
        {threeDays150Miles.thirdDayDate && <p className={styles.calculationDate}>{threeDays150Miles.thirdDayDate && '&  '} {new Date(threeDays150Miles.thirdDayDate).toLocaleDateString('en-us', { weekday: 'short', year: 'numeric', month: 'numeric', day: 'numeric', timeZone: 'UTC' })}</p>}
      </div>

      <CalculationThreeDays150Params
        commonValues={commonValues}
        threeDays150Miles={threeDays150Miles}
        department={department}
        unpDepartment={unpDepartment}
        selectedMiscCheckMarks={selectedMiscCheckMarks}
        formChange={formChange}
        resetLastTarget={resetLastTarget}
        checkboxValueChange={checkboxValueChange}

        editorState={editorState}
        calculationData={calculationData}
        tags={tags}
        popUpShown={popUpShown}
        setPreviewText={setPreviewText}
        setOptionsPreviewText={setOptionsPreviewText}
        setShowGenerateEmail={setShowGenerateEmail}
        furniture={furniture}
        roomsAreas={roomsAreas}
        setTagsValuesDefault={setTagsValuesDefault}
        customTagsValues={customTagsValues}
      />
    </section >
  );
};
